import React, { useContext } from "react";
import { BooleanField, Datagrid, DateField, List, TextField } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const ActivityTypeList = (props) => {

    const context = useContext(AppContext)
    return (
        <List exporter={false} bulkActionButtons={false}
            title={'Tipos de movimentação'}
            sort={{ field: 'name', order: 'ASC' }}
            {...props}
        >
            <Datagrid rowClick={'edit'}>
                <TextField source="name" label={'Nome'} />
                <BooleanField source="is_hearing" label={'Audiência?'} />
                <BooleanField source="requires_videoconference" label={'Requer videoconferência?'} />
                {context.profile.name === ProfileEnum.SUPERADMIN && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
                {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source="institution_branch.name" label={'Unidade'} />}
                <DateField source="created_at" label={'Criado em'} />
            </Datagrid>
        </List>
    )
}


export default ActivityTypeList;